<template>
  <section class="availability">
    <!-- Progress Bar will be taken out until we have the ability to calculate the percentage -->
    <!-- <p class="percentage"><span>78%</span> Reserved</p>
    <div class="progress-bar">
      <div></div>
    </div>-->
    <p class="rooms-available">{{minAvailability}}</p>
  </section>
</template>

<script>
export default {
  props: {
    hotel: Object
  },

  computed: {
    // eslint-disable-next-line space-before-function-paren
    minAvailability() {
      let totalRoomsAvailable = 0;

      for (let roomType in this.hotel.realInventory) {
        totalRoomsAvailable += this.hotel.realInventory[roomType]
          .maxAvailablity;
      }
      return totalRoomsAvailable + " rooms available";
    }
  }
};
</script>

<style lang="scss" scoped>
.availability {
  margin: 0 20px;
  display: flex;
  align-items: center;

  p.percentage {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 10px;

    span {
      font-size: 18px;
    }
  }

  div.progress-bar {
    margin-bottom: 12px;
    height: 10px;
    background: #e9e9e9;
    border-radius: 2.75px;

    div {
      border-radius: 2.75px;
      height: 100%;
      background: $secondary-black;
      width: 78%;
    }
  }

  p.rooms-available {
    font-size: 18px;
    display: flex;

    &::before {
      content: url("../../assets/hotel-detail/ic_room_black.svg");
      padding-right: 10px;
    }
  }
}

@media (min-width: 768px) {
  .availability {
    min-width: 250px;
    max-height: 150px;
    padding: 30px;
    border: 1px solid #e9e9e9;
  }
}
</style>
